import jetcoreImg from "../../../../assets/JETCORE.png";
import jetcoreFcImg from "../../../../assets/JETCORE-FC.png";
import jasperImg from "../../../../assets/JASPER.png";
import atheraImg from "../../../../assets/ATHERA.png";

const S3_BASE = "https://vecros-docs.s3.eu-north-1.amazonaws.com/Developers/device_registration/images";
const S3_Video_Url="https://vecros-docs.s3.eu-north-1.amazonaws.com/Developers/device_registration/Device_Registration_Video.mp4"
export const deviceRegistrationGuide = {
  id: "device-registration",
  title: "Manage Devices and Add New Hardware",
  description:
    "Learn how to access the device section, register new hardware, and manage your devices in the Vecros platform.",
  thumbnail: `${S3_BASE}/thumbnail.png`,
  videoUrl: `${S3_Video_Url}`,
  videoDuration: 96,
  lastUpdated: "May 01, 2026",
  steps: [
    {
      id: "step-01",
      stepNumber: 1,
      title: "Introduction",
      description:
        "In this guide, you will learn how to access the device section and add new devices to the Vecros platform effectively. Follow each step carefully to complete the registration process.",
      imageUrl: `${S3_BASE}/step-01.png`,
      videoTimestamp: 0,
      tips: [
        "Make sure you have admin access before starting.",
        "Have your device (e.g. Raspberry Pi) ready and connected to the internet.",
      ],
    },
    {
      id: "step-02",
      stepNumber: 2,
      title: "Access Vecros Account Login",
      description:
        "Navigate to the Vecros login page. Enter your registered email address and password, then click the Login button to access your Vecros account dashboard.",
      imageUrl: `${S3_BASE}/step-02.png`,
      videoTimestamp: 7,
      tips: [
        "Use the email associated with your Vecros developer account.",
        "If you forgot your password, use the Forgot Password link on the login page.",
      ],
    },
    {
      id: "step-03",
      stepNumber: 3,
      title: "Navigate to Devices Section",
      description:
        "Once logged in, click the Devices tab in the left sidebar navigation to view and manage your registered devices within the Vecros platform.",
      imageUrl: `${S3_BASE}/step-03.png`,
      videoTimestamp: 14,
      tips: [
        "The Devices section is listed under the main navigation menu.",
      ],
    },
   
    {
      id: "step-04",
      stepNumber: 4,
      title: "Initiate Adding a New Device",
      description:
        "Click the Add Device button in the top-right corner of the Devices page. This will generate a unique registration command specific to your account that you will run on your device.",
      imageUrl: `${S3_BASE}/step-04.png`,
      videoTimestamp: 30,
      tips: [
        "Each generated command is unique and tied to your account.",
        "Do not share this command with others.",
      ],
    },
    {
      id: "step-05",
      stepNumber: 5,
      title: "Reveal Full Command Details",
      description:
        "Click Show full command to display the complete command needed for device configuration.",
      imageUrl: `${S3_BASE}/step-05.png`,
      videoTimestamp: 40,
      tips: [
        "Use the expand button to see the full command if it is truncated.",
      ],
    },
    {
      id: "step-06",
      stepNumber: 6,
      title: "Execute Command Action",
      description:
        "Click here to perform the next step related to the displayed command within the developer interface.",
      imageUrl: `${S3_BASE}/step-06.png`,
      videoTimestamp: 50,
      tips: [
        "Make sure your device is connected to the internet before running the command.",
        "The command requires sudo privileges on the device.",
        "Installation typically takes 30–60 seconds.",
      ],
    },
    {
      id: "step-07",
      stepNumber: 7,
      title: "Proceed with Command Execution",
      description:
        "Click here again to continue with the command execution or related device setup process.",
      imageUrl: `${S3_BASE}/step-07.png`,
      videoTimestamp: 58,
      tips: [
        "If the device does not appear, wait 10–15 seconds and refresh again.",
        "Check that the terminal command completed without errors.",
      ],
    },
    {
      id: "step-08",
      stepNumber: 8,
      title: "Command Execution in jetcore Terminal",
      description:
        "Here after copy the curl command from the developers app we paste that command in the jetcore terminal for finishing the jetcore registration process.",
      imageUrl: `${S3_BASE}/step-08.png`,
      videoTimestamp: 65,
      tips: [
        "Copy the Device ID from this page for use in API calls.",
      ],
    },
    {
      id: "step-9",
      stepNumber: 9,
      title: "Enter the batch Id of the device",
      description:
        "During registration if the script does not find the batch id in the device then they prompt the user to enter the batch id from the device and if that batch id is in the database then registration process is completed.",
      imageUrl: `${S3_BASE}/step-09.png`,
      videoTimestamp: 70,
      tips: [
        "You can select multiple devices at once for bulk operations.",
      ],
    },
    {
      id: "step-10",
      stepNumber: 10,
      title: "Select Specific Device",
      description:
        "Click vecros_jcb_1234 to view detailed information and settings for this particular device.",
      imageUrl: `${S3_BASE}/step-10.png`,
      videoTimestamp: 75,
      tips: [
        "Your device registration is now complete.",
        "You can now use the Device ID to connect via the API or Remote SSH.",
      ],
    },
    {
      id: "step-11",
      stepNumber: 11,
      title: "Return to Devices Overview",
      description:
        "Click the Devices tab to return to the main devices overview page within the Vecros Developer Portal.",
      imageUrl: `${S3_BASE}/step-11.png`,
      videoTimestamp: 75,
      tips: [
        "Your device registration is now complete.",
        "You can now use the Device ID to connect via the API or Remote SSH.",
      ],
    },
  ],
};


export const docsRegistry = [
  {
    id: "device-registration",
    title: "Manage Devices and Add New Hardware",
    description:
      "Learn how to register new devices, manage hardware, and access remote SSH in the Vecros platform.",
    thumbnail: `${S3_BASE}/thumbnail.png`,
    stepCount: 11,
    duration: "1 min 20 sec",
    category: "Devices",
    lastUpdated: "May 01, 2026",
  },
];


export const devicesRegistry = [
  {
    id: "athera",
    name: "ATHERA",
    tagline: "Perception without limits.",
    image: atheraImg,
    guides: [],
  },
  {
    id: "jasper",
    name: "JASPER",
    tagline: "Intelligence at the edge.",
    image: jasperImg,
    guides: [],
  },
  {
    id: "jetcore",
    name: "JETCORE",
    tagline: "The brain your autonomy runs on.",
    image: jetcoreImg,
    guides: [docsRegistry[0]],
  },
  {
    id: "jetcore-fc",
    name: "JETCORE-FC",
    tagline: "Precision control, engineered for flight.",
    image: jetcoreFcImg,
    guides: [],
  },
];